// Reliable inline muted autoplay across browsers — especially iOS Safari.
//
// React assigns `muted` as a DOM *property*, not as the HTML `muted`
// *attribute*. Under a strict autoplay policy (which iOS enforces) the browser
// can evaluate the `autoplay` attribute while the element still looks unmuted
// and block playback; React setting `.muted = true` a tick later does not
// retry. Setting muted explicitly and then calling play() — which is permitted
// for muted media without a user gesture — makes autoplay deterministic.
//
// Pass as a ref callback: <video ref={autoplayInline} muted autoPlay playsInline ... />
const tryPlay = el => {
  const playPromise = el.play()
  if (playPromise && typeof playPromise.catch === "function") {
    // Mobile Safari frequently rejects play() here because the freshly
    // mounted element hasn't buffered any data yet (unlike desktop, which
    // tends to already have it cached). Retry once real data is available
    // instead of silently leaving the video black forever.
    playPromise.catch(() => {
      el.addEventListener("canplay", () => el.play().catch(() => {}), {
        once: true,
      })
    })
  }
}

export const autoplayInline = el => {
  if (!el) return
  el.muted = true
  el.defaultMuted = true
  el.setAttribute("muted", "")
  el.playsInline = true
  el.setAttribute("playsinline", "")
  tryPlay(el)
}
